import React from "react";
import styled from "styled-components";
import { colors } from "../../../../utils/theme";
import PDF from "./../../../../assets/politicas.pdf"

interface RadioProps {
  label: string;
  value: string;
  state: {
    field: string;
    isValid: boolean | null;
  };
  changeState: (newState: { field: string; isValid: boolean | null }) => void; // Actualiza aquí también
}

const RadioContainer = styled.div<{ $isValid: boolean }>`
  display: flex;
  align-items: center;

  a{
    text-decoration: none;
  }

  a:hover{
    text-decoration: underline;
    text-decoration-color: ${colors.fifth};
  }
  
  .radio-input {
    margin-right: 8px;
  }

 
  .aceptoError{
    color: red;
    margin-right: 5px;
  }
  .acepto{
    margin-right: 5px;
  }
  .polity{
    color: ${colors.fifth};
  }
`;

const Radio_Form: React.FC<RadioProps> = ({
  label,
  value,
  state,
  changeState,
}) => {
  const handleChange = () => {
    changeState({ ...state, field: value, isValid: true });
  };

  const isValid = state.isValid !== null ? state.isValid : false;

  return (
    <>
      <RadioContainer $isValid={isValid}>
        <input
          type="radio"
          className="radio-input"
          checked={state.field === value}
          onChange={handleChange}
          value={value}
        />
        <a href={PDF} target="_blank" rel="noreferrer">
          {!state.isValid && <span className="aceptoError">Aceptar </span>}
          {!state.isValid && <span className="polity"> política de privacidad</span>}
          {state.isValid && <span className="acepto">Acepto </span>}
          {state.isValid && <span className="polity"> política de privacidad</span>}
        </a>
      </RadioContainer>
    </>
  );
};

export default Radio_Form;